import React, { Component, Suspense } from "react";
import $ from "jquery";
import bolgtemp from "../image/icons/blogging.png";
import { apiCalling, apiCallingWithoutToken } from "../apiService";
import InnerHTML from "dangerously-set-html-content";
import { Helmet } from "react-helmet";
import { RiArrowRightSLine } from "react-icons/ri";
import Arrowleft from "../image/ida/Arrow_left_light.png";
import { HiOutlineClock } from "react-icons/hi2";
import { IoEyeOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { GoArrowUpRight } from "react-icons/go";
import moment from "moment";
const folderName = window.sessionStorage.getItem("homeName");

const Home = React.lazy(() => import("../" + folderName + "/home"));
const Header = React.lazy(() => import("../" + folderName + "/header"));
const Footer = React.lazy(() => import("../" + folderName + "/footer"));
export default class HealthblogPost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectCategotyList: [],
      resultData: [],
      showMessage: [],
      relatedBlogs: [],
    };
  }

  componentDidMount() {
    if (folderName === null) {
      window.sessionStorage.setItem("pathname", window.location.pathname);
      window.location.href = "/";
    }

    this.categorySelectList();
    this.showBlogDetails();
  }
  showBlogDetails() {
    const dataList = {
      method: "POST",
      body: JSON.stringify({
        functionName: "getDoctorHealthArticles",
        siteId: window.sessionStorage.getItem("siteId"),
        healthInfoId: this.props.match.params.blogId,
      }),
    };
    $(".loader").show();
    apiCallingWithoutToken(dataList).then((data) => {
      $(".loader").hide();
      if (data.success == "1" && data.result.length > 0) {
        this.categorySearch(data?.result?.[0]?.healthInfoCategoryId);
        this.setState({ resultData: data.result[0] });
      }
    });
  }
  categorySelectList() {
    $(".loader").show();
    const saveField = {
      method: "POST",
      body: JSON.stringify({
        functionName: "getHealthInfoCommonData",
        siteId: window.sessionStorage.getItem("siteId"),
      }),
    };
    apiCallingWithoutToken(saveField).then((data) => {
      $(".loader").hide();
      if (data.success == "1") {
        this.setState({
          selectCategotyList: data.result,
        });
      }
    });
  }

  categorySearch(categoryId) {
    const dataList = {
      method: "POST",
      body: JSON.stringify({
        functionName: "getDoctorHealthArticles",
        siteId: window.sessionStorage.getItem("siteId"),
        categoryId: categoryId,
      }),
    };
    apiCallingWithoutToken(dataList).then((data) => {
      if (data.success == "1" && data.result.length > 0) {
        this.setState({ relatedBlogs: data.result });
      }
    });
  }

  srcTypeImage(ev) {
    ev.target.src = bolgtemp;
  }

  render() {
    return (
      <div className="pamba-wrapper">
        <Suspense fallback={<div></div>}>
          <section>
            <Header />
          </section>
        </Suspense>
        <Helmet>
          <title>{this.props.match.params.shortDescri}</title>
          <meta
            name="description"
            content={this.props.match.params.shortDescri}
          />
        </Helmet>

        <div className="telehealthfeaturehead text-md-left">
          <div className="breadcrumb-main mb-1">
            <ul className="bread-crumb-ul">
              <li className="breadcrumb-light">Home</li>
              <li>
                <RiArrowRightSLine />
              </li>
              <li>Blog</li>
            </ul>
          </div>
          <span>
            <img
              src={Arrowleft}
              alt="arrowleft"
              className="img-fluid mr-2 cursor-pointer"
              onClick={() => this.props.history.goBack()}
            />
          </span>
          {this.state.resultData.healthInfoTitle}
        </div>
        <div className="drListMain">
          <div className="container blog-wrapper">
            <div className="row mt-2">
              {/* <div className="col-lg-3 col-md-4 mb-3">
                  <div className="category-main">                    
                    <div className="category-list">
                    {this.state.selectCategotyList.map((obj) => (
                      // <a href={"blog-"+obj.categoryId}><div className="category-sub">{obj.categoryName}</div></a>
                      <Link to={"/blog-"+obj.categoryId}><div className="category-sub">{obj.categoryName}</div></Link>
                      ))}
                    </div>
                  </div>
                </div>                */}
              <div className="col-lg-12 col-md-12 mb-5" id="blog-detailsId">
                <div className="col-md-12 p-0">
                  <h1 className="bloguser-text mt-md-4">
                    {this.state.resultData.healthInfoTitle}{" "}
                  </h1>
                  {/* <h2 className="Blogsubtext">Sub heading</h2> */}

                  <div className="LocalsearchImgdiv">
                    <img
                      onError={this.srcTypeImage}
                      src={this.state.resultData.imageName}
                      alt="Blog Image"
                      className="img-fluid mb-3 LocalsearchImg"
                    ></img>
                  </div>

                  <div className="d-flex bloguserList-text-info mt-2 mb-4 justify-content-between align-items-center">
                    {/* <span className="bloguserList-text-info-span">
                      <IoEyeOutline size={18} className="text-dark mr-1"/> 1.2k
                    </span> */}
                    <span className="bloguserList-text-info-span">
                      <HiOutlineClock size={18} className="text-dark mr-1" />
                      {moment(
                        this.state.resultData.healthInfoPostDate,
                        "DD-MMM-YYYY",
                      ).format("MMM DD, YY")}
                    </span>
                    <div className="title-blog">
                      {this.state.resultData.healthInfoCategory}
                    </div>
                  </div>
                  {this.state.resultData.shortDescription ? (
                    <p className="Blogsubtext">
                      <InnerHTML
                        html={this.state.resultData.shortDescription}
                      />
                    </p>
                  ) : (
                    ""
                  )}
                  {this.state.resultData.description ? (
                    <p className="Blogsubtext">
                      <InnerHTML
                        html={
                          this.state.resultData.description === "null"
                            ? ""
                            : this.state.resultData.description
                        }
                      />
                    </p>
                  ) : (
                    ""
                  )}
                </div>

                {this.state.relatedBlogs.length > 0 && (
                  <div>
                    <h3 className="sub-heading mb-3">Related posts</h3>
                    <div className="row mt-1 mt-md-0">
                      {this.state.relatedBlogs.map((data, index) => (
                        <div className="blog-listbox" key={index}>
                          <div className="blog-listImgDiv">
                            <img
                              onError={this.srcTypeImage}
                              src={data.imageName}
                              alt="Blog Image Name"
                              className="img-fluid blog-listImg"
                            ></img>
                          </div>
                          <div className="blog-list-detils">
                            <div className="blogtag-name">
                              {data.healthInfoTitle}
                            </div>
                            <div className="bloguserList-text bloguserList-text-custom">
                              {data.shortDescription}
                            </div>
                            <div className="d-flex bloguserList-text-info mt-2 mb-4">
                              {/* <span className="bloguserList-text-info-span">
                                <IoEyeOutline size={18} className="text-dark"/> 1.2k
                              </span> */}
                              <span className="bloguserList-text-info-span">
                                <HiOutlineClock
                                  size={18}
                                  className="text-dark"
                                />{" "}
                                {moment(
                                  data.healthInfoPostDate,
                                  "DD-MMM-YYYY",
                                ).format("MMM DD, YY")}
                              </span>
                            </div>
                            <Link
                              // to={"/HealthBlog/" + data.healthInfoId + "/" + slug}
                              className="readmoreBlog"
                            >
                              View more
                              <GoArrowUpRight size={14} className="ms-2" />
                            </Link>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Suspense fallback={<div></div>}>
          <section>
            <Footer />
          </section>
        </Suspense>
      </div>
    );
  }
}
